export interface RuntimeConfig {
  apiBaseUrl: string;
  tenantId: string;
}

export function getRuntimeConfig(
  env: Record<string, string | boolean | undefined>,
): RuntimeConfig {
  const rawUrl = env.VITE_API_BASE_URL;
  if (typeof rawUrl !== 'string') {
    throw new Error('VITE_API_BASE_URL is required for the Dashboard');
  }
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    throw new Error('VITE_API_BASE_URL must be an absolute URL');
  }
  if (url.protocol !== 'https:' && url.hostname !== 'localhost') {
    throw new Error('VITE_API_BASE_URL must use HTTPS outside localhost');
  }
  const tenantId = env.VITE_API_TENANT_ID;
  if (typeof tenantId !== 'string' || !tenantId.trim()) {
    throw new Error('VITE_API_TENANT_ID is required for the Dashboard');
  }
  return {
    apiBaseUrl: rawUrl.replace(/\/$/, ''),
    tenantId: tenantId.trim(),
  };
}

export function assertProductionRuntimeConfig(): void {
  if (import.meta.env.MODE === 'test') return;
  getRuntimeConfig(import.meta.env);
}
